module.exports = __webpack_public_path__ + "img/rosemount-248-wireless-temperature-transmitter.b1cf80dd.png";